<div class="workshop-list" *transloco="let t; prefix: 'assetSettings'">
  <div class="workshop-list__header">
    <h3>{{ t('workshops.listTitle') }}</h3>
    <span class="fw-bold">({{ workshops.length }})</span>
  </div>

  @if (isLoading) {
    <div class="workshop-list__loading">
      <div class="spinner-border" role="status" [attr.aria-label]="t('common.loadingAria')"></div>
    </div>
  }

  @if (!isLoading) {
    @for (workshop of workshops; track workshop.id) {
      <div class="workshop-card"
        [id]="'workshop-card-' + workshop.id"
        [class.workshop-card--selected]="workshop.id === selectedWorkshop?.id"
        (click)="workshopSelected.emit(workshop)">
        <span class="workshop-card__name">{{ workshop.name }}</span>
        <span class="workshop-card__address" [title]="workshop.location">{{ workshop.location }}</span>
        <span class="workshop-badge">{{ workshopTypeLabels[workshop.workshopType] }}</span>
      </div>
    }

    @if (workshops.length === 0) {
      <div class="workshop-list__empty">
        <img src="assets/icons/exclamation_circle.svg" [attr.alt]="t('workshops.emptyTitle')">
        <h4>{{ t('workshops.emptyTitle') }}</h4>
        <p>{{ t('workshops.emptyDescription') }}</p>
      </div>
    }
  }
</div>
